import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "statusSelect",
    "readyNotificationSection",
    "shippedNotificationSection",
    "readyNotifyCheckbox",
    "shippedNotifyCheckbox",
    "readyRecipientsInput",
    "shippedRecipientsInput"
  ]

  static values = {
    readyStatus: { type: String, default: "Ready" },
    shippedStatus: { type: String, default: "Shipped" },
    defaultRecipients: String,
    readyNotified: Boolean,
    shippedNotified: Boolean
  }

  connect() {
    this.syncNotificationSections()
  }

  statusChanged() {
    this.syncNotificationSections()
  }

  notifyCustomerChanged(event) {
    if (event.target === this.readyNotifyCheckboxTarget) {
      this.syncReadyRecipientsEnabled()
    } else if (event.target === this.shippedNotifyCheckboxTarget) {
      this.syncShippedRecipientsEnabled()
    }
  }

  syncNotificationSections() {
    if (!this.hasStatusSelectTarget) return

    const status = this.statusSelectTarget.value
    this.syncReadySection(status === this.readyStatusValue)
    this.syncShippedSection(status === this.shippedStatusValue)
  }

  syncReadySection(isActive) {
    if (!this.hasReadyNotificationSectionTarget) return

    const showForm = isActive && !this.readyNotifiedValue
    this.readyNotificationSectionTarget.classList.toggle("hidden", !showForm)
    this.setReadyNotifyCheckboxEnabled(showForm)

    if (!showForm) return

    if (this.hasReadyRecipientsInputTarget && !this.readyRecipientsInputTarget.value.trim()) {
      this.readyRecipientsInputTarget.value = this.defaultRecipientsValue
    }

    this.syncReadyRecipientsEnabled()
  }

  syncShippedSection(isActive) {
    if (!this.hasShippedNotificationSectionTarget) return

    const showForm = isActive && !this.shippedNotifiedValue
    this.shippedNotificationSectionTarget.classList.toggle("hidden", !showForm)
    this.setShippedNotifyCheckboxEnabled(showForm)

    if (!showForm) return

    if (this.hasShippedRecipientsInputTarget && !this.shippedRecipientsInputTarget.value.trim()) {
      this.shippedRecipientsInputTarget.value = this.defaultRecipientsValue
    }

    this.syncShippedRecipientsEnabled()
  }

  syncReadyRecipientsEnabled() {
    if (!this.hasReadyRecipientsInputTarget || !this.hasReadyNotifyCheckboxTarget) return

    const enabled = this.readyNotifyCheckboxTarget.checked && !this.readyNotifyCheckboxTarget.disabled
    this.readyRecipientsInputTarget.disabled = !enabled
  }

  syncShippedRecipientsEnabled() {
    if (!this.hasShippedRecipientsInputTarget || !this.hasShippedNotifyCheckboxTarget) return

    const enabled = this.shippedNotifyCheckboxTarget.checked && !this.shippedNotifyCheckboxTarget.disabled
    this.shippedRecipientsInputTarget.disabled = !enabled
  }

  setReadyNotifyCheckboxEnabled(enabled) {
    if (this.hasReadyNotifyCheckboxTarget) {
      this.readyNotifyCheckboxTarget.disabled = !enabled
    }
    if (!enabled && this.hasReadyRecipientsInputTarget) {
      this.readyRecipientsInputTarget.disabled = true
    }
  }

  setShippedNotifyCheckboxEnabled(enabled) {
    if (this.hasShippedNotifyCheckboxTarget) {
      this.shippedNotifyCheckboxTarget.disabled = !enabled
    }
    if (!enabled && this.hasShippedRecipientsInputTarget) {
      this.shippedRecipientsInputTarget.disabled = true
    }
  }
}
